import React, { Component } from 'react';

import MetricsEquation from '../MetricsEquation/MetricsEquation';
import MetricsFilter from '../MetricsFilter/MetricsFilter';
import MetricsList from '../MetricsList/MetricsList';

import './Metrics.scss';

class Metrics extends Component {
  render() {
    return (
      <div className="metrics">
        <div className="container">
          <div className="metrics__inner">
            <MetricsEquation />
            <MetricsFilter />
            <MetricsList />
          </div>
        </div>
      </div>
    )
  }
}

export default Metrics;


// WEBPACK FOOTER //
// ./src/components/Metrics/Metrics.js